<template>
  <div>
    <input :id="id" type="checkbox" class="checkbox" @click="toggle()" :checked="value" />
    <label :for="id" class="switch">
      <span class="switch__circle">
        <span class="switch__circle-inner"></span>
      </span>
      <span class="switch__left w-1/2">On</span>
      <span class="switch__right w-1/2">Off</span>
    </label>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  props: ['value', 'id'],
  mounted() {
    this.$emit('input', this.value)
  },
  methods: {
    toggle() {
      this.$emit('input', !this.value)
    }
  }
}
</script>
<style lang="scss" scoped>
.checkbox {
  display: none;
}

.switch {
  align-items: center;
  background-color: gray;
  border-radius: 500px;
  cursor: pointer;
  display: flex;
  height: 26px;
  justify-content: space-between;
  padding: 0 10px;
  position: relative;
  user-select: none;
  // width: 60px;
}

.checkbox:checked ~ .switch {
  background-color: #101840;
  color: #59c8c1;
}

.checkbox:not(:checked) ~ .switch {
  background-color: #ced5de;
  color: #748497;
}

.switch__left,
.switch__right {
  font-weight: bold;
  font-size: 12px;
  text-transform: uppercase;
}

.checkbox:checked ~ .switch .switch__right {
  visibility: hidden;
}

.checkbox:not(:checked) ~ .switch .switch__left {
  visibility: hidden;
}

.switch__circle {
  height: 26px;
  padding: 5px;
  position: absolute;
  transition: all 0.1s linear;
  width: 26px;
}

.checkbox:checked ~ .switch .switch__circle {
  left: calc(100% - 26px);
  right: 0;
}

.checkbox:not(:checked) ~ .switch .switch__circle {
  left: 0;
  right: calc(100% - 26px);
}

.checkbox:checked ~ .switch .switch__circle .switch__circle-inner {
  background-color: #59c8c1;
}

.checkbox:not(:checked) ~ .switch .switch__circle .switch__circle-inner {
  background-color: #748497;
}

.switch__circle-inner {
  background-color: white;
  border-radius: 50%;
  display: block;
  height: 100%;
  width: 100%;
}
</style>
